import { render, staticRenderFns } from "./VendorDetail.vue?vue&type=template&id=1f46eb16&scoped=true"
import script from "./VendorDetail.vue?vue&type=script&lang=js"
export * from "./VendorDetail.vue?vue&type=script&lang=js"
import style0 from "./VendorDetail.vue?vue&type=style&index=0&id=1f46eb16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46eb16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f46eb16')) {
      api.createRecord('1f46eb16', component.options)
    } else {
      api.reload('1f46eb16', component.options)
    }
    module.hot.accept("./VendorDetail.vue?vue&type=template&id=1f46eb16&scoped=true", function () {
      api.rerender('1f46eb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vendor/VendorDetail.vue"
export default component.exports